import { Prohibit, Warning, Wrench, Clock, CheckCircle } from "@phosphor-icons/react";

// Dominant operational-effect chip for a fault. Colour + icon + TEXT (accessibility).
// Data comes from the backend-derived `operational_effect` so it is the single source of truth.
const STYLES = {
  red:    "bg-red-100 text-red-800 border-red-300",
  amber:  "bg-amber-100 text-amber-900 border-amber-300",
  yellow: "bg-yellow-100 text-yellow-800 border-yellow-300",
  grey:   "bg-slate-100 text-slate-700 border-slate-300",
  green:  "bg-emerald-100 text-emerald-800 border-emerald-300",
};
const ICONS = { prohibit: Prohibit, warning: Warning, wrench: Wrench, clock: Clock, "check-circle": CheckCircle };

export function FaultEffectBadge({ effect, testid }) {
  if (!effect) return null;
  const Icon = ICONS[effect.icon] || Wrench;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-bold ${STYLES[effect.colour] || STYLES.grey}`}>
      <Icon size={13} weight="bold" />{effect.label}
      {effect.secondary && <span className="font-medium opacity-70 ml-1">· {effect.secondary}</span>}
    </span>
  );
}
